<template>
  <div class="position-relative">
    <b-container fluid class="ps-0">
      <b-row>
        <b-col lg="3" xl="2" xxl="2" cols="2" class="leftsidebar">
          <LeftBar pagename="ItemMasterDetails" masterheading="Item Master" v-model="datas" :listed="sidebardata"
            :storestatus="false"></LeftBar>
          <a class="back-btn" @click="$router.push({ path: '/ItemMasterTableview' })">
            <img alt="Vue logo" class="back" src="../../../../../../assets/Img/icons/backtoright.svg" width="125"
              height="125" />
          </a>
        </b-col>
        <b-col lg="9" xl="10" xxl="10" class="other-tabs">
          <div class="sidebar-static-header">
            <p class="light-txt count-shows">{{ datas.Code }}</p>
            <!-- <Headerlayout :headertext=datas.Name></Headerlayout> -->
            <!-- <p class="light-txt count-shows">SUP9856</p>
          <span class="sidebar-heading">Emergency Supplies</span> -->
            <span class="sidebar-heading">{{ datas.Name }}</span>
            <!-- {{ datas.Id }}aa -->
          </div>

          <b-container fluid>
            <b-row>
              <TabView class="tabview-custom" :scrollable="true">
                <TabPanel>
                  <template #header>
                    <i class="pi pi-align-left pe-3"></i>
                    <span>Details</span>
                  </template>
                  <DetailsTab :propsParams="datas.Id" />
                </TabPanel>
                <TabPanel>
                  <template #header>
                    <i class="pi pi-shopping-bag pe-3"></i>
                    <span>Stores</span>
                  </template>
                  <b-row>
                    <b-col>
                      <ItemStoreMappingDetailsTableView :propsParams="datas.Id" />
                    </b-col>
                  </b-row>
                </TabPanel>

                <TabPanel>
                  <template #header>
                    <i class="pi pi-users pe-3"></i>
                    <span>Suppliers</span>
                  </template>
                  <b-row>
                    <b-col>
                      <ItemSupplierMappingDetailsTableView :propsParams="datas.Id" />
                    </b-col>
                  </b-row>
                </TabPanel>
                <TabPanel>
                  <template #header>
                    <i class="pi pi-save pe-3"></i>
                    <span>Documents</span>
                  </template>
                  <b-row>
                    <b-col>
                      <ItemDetailsDocumentsTableView />
                    </b-col>
                  </b-row>
                </TabPanel>
                <TabPanel>
                  <template #header>
                    <i class="pi pi-align-left pe-3"></i>
                    <span>Logs</span>
                  </template>
                  <b-row>
                    <b-col>
                      <Log></Log>
                    </b-col>
                  </b-row>
                </TabPanel>
              </TabView>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
    <div class="center" v-if="loading">
      <Loader :loading="loading" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import LeftBar from "../../../../components/MasterDetails/LeftSideBar.vue";
import Details from "../../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import MemberDetails from "../../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";

import Log from "../../../../components/MasterDetails/TabsPage/Log.vue";
import ItemStoreMappingDetailsTableView from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ItemStoreMappingDetailsTableView.vue";
import ItemSupplierMappingDetailsTableView from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ItemSupplierMappingDetailsTableView.vue";
import ItemDetailsDocumentsTableView from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ItemDetailsDocumentsTableView.vue";
import service from "../../../../../../modules/Inventory/Service/ItemMasService";
import DetailsTab from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ItemDetailsTabDetails.vue";
import { useRoute } from "vue-router";
import Loader from "../../../../../../components/FormComponents/Loader.vue";

// import from '../../../../components/MasterDetails/';
// import from '../../../../components/MasterDetails/';

export default defineComponent({
  components: {
    LeftBar,
    Details,
    MemberDetails,
    Log,
    ItemStoreMappingDetailsTableView,
    ItemSupplierMappingDetailsTableView,
    ItemDetailsDocumentsTableView,
    DetailsTab,
    Loader,
  },

  setup() {
    // let List = ref([]);
    const loading = ref(false);

    const sidebardata = ref([]);
    // let Id = ref();
    let datas = ref({
      Id: ref(),
      Name: "",
      Code: "",
    });
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    onMounted(() => {
      IsShow();
    });

    const paramValues = ref({
      Id: "",
      Type: "",
    });

    const route = useRoute();

    watch(
      () => route.query.id,
      (newVal: any) => {
        debugger;
        // alert('newVal')
        paramValues.value.Id = newVal;
        paramValues.value.Type = route.query.Type as string;
      }
    );
    async function IsShow() {
      debugger;
      loading.value = true;
      try {
        const data_response = await service.getdata();
        sidebardata.value = data_response["result"]

        const oldKey = "ItemName";
        const newKey = "Name";
        sidebardata.value = data_response["result"].filter((items) => items.HospitalId == usersData.OrganizationId)
          .sort((a, b) => a.ItemName.localeCompare(b.ItemName)).map((item) => {
            const newItem = { ...item, [newKey]: item[oldKey] };
            delete newItem[oldKey];
            return newItem;
          });
        let obj = sidebardata.value.filter(
          (items) => items["Id"] == route.query.id
        );
        datas.value.Name = obj[0]["Name"];
        datas.value.Code = obj[0]["Code"];
        datas.value.Id = obj[0]["Id"];
        console.log(sidebardata.value);
        loading.value = false;
      } catch (error) {
        loading.value = false;

        alert(error);
      }
    }
    return {
      sidebardata,
      IsShow,
      datas,
      loading,
    };
  },
});
</script>

<style lang="scss" scoped>
.sidebar-static-header {
  padding: 15px 15px 20px 45px;
  font-weight: 600;
  border-bottom: 5px solid #f8f9fe;
  position: sticky;
  left: 0px;
  top: 0px;
  background-color: #f8f9fe;
  z-index: 1;
}

.other-tabs {
  height: 90vh;
  overflow: auto;
}

// .overall-bg {
//   section {
//     width: 100%;
//     overflow: hidden;
//   }
// }

.leftsidebar {
  position: relative;
  padding-right: 0px !important;
}

.back-btn {
  background-color: #0148e2;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  position: absolute;
  top: 20px;
  right: -20px;
  z-index: 10;

  .back {
    width: 20px;
    position: absolute;
    top: -45px;
    left: 8px;
    filter: invert(100%) sepia(2%) saturate(0%) hue-rotate(141deg) brightness(98%) contrast(108%);
  }
}

.count-shows {
  font-weight: 300;
  padding-bottom: 10px;
}
</style>
